import _ from 'lodash';
import { IsTimeoutException, TaskSource, withTimeout } from 'library-components/utils/task';
import { Channel, E_ClientCommand, E_ServerCommand } from './share';
import { Uid } from './Uid';
export class ServerService {
    uid = new Uid('login_embed:service:uid');
    clientReadySource = new TaskSource();
    outputChannel = new Channel({
        window: window.parent,
    });
    async start() {
        window.addEventListener('message', event => {
            const ev_data = event.data;
            if (_.has(ev_data, 'uid')) {
                const { uid, command, data, } = ev_data;
                if (command === E_ClientCommand.SwitchIframeResizer) {
                    this.onSwitchIframeResizer(uid, data);
                }
                this.outputChannel.maybeMarkAskResolved(uid, data);
            }
        }, false);
        while (true) {
            try {
                // 4000ms 重发一次请求
                await withTimeout(this.ping(), 4000);
                this.clientReadySource.Resolve();
                return;
            }
            catch (e) {
                if (IsTimeoutException(e)) {
                    // retry
                }
                else {
                    throw e;
                }
            }
        }
    }
    get ClientReady() {
        return this.clientReadySource.Promise;
    }
    ping() {
        return this.outputChannel.ask({
            command: E_ServerCommand.Ping,
            uid: this.uid.Next,
        });
    }
    fireRedirectTo(url) {
        this.outputChannel.fire({
            command: E_ServerCommand.RedirectTo,
            data: url,
            uid: this.uid.Next,
        });
    }
    askMessageBox(data) {
        return this.outputChannel.ask({
            command: E_ServerCommand.MessageBox,
            data,
            uid: this.uid.Next,
        });
    }
    onSubmit() {
        this.outputChannel.fire({
            command: E_ServerCommand.Submit,
            uid: this.uid.Next,
        });
    }
    onSwitchIframeResizer(uid, enabled) {
        if (enabled) {
            document.body.classList.remove('mobile');
        }
        else {
            document.body.classList.add('mobile');
        }
        if ('parentIFrame' in window) {
            const parentIFrame = window.parentIFrame;
            parentIFrame.autoResize(enabled);
            if (enabled) {
                // autoResize(true)时候有时候有bug 这里强制reset!
                parentIFrame.reset();
            }
            else {
                // mobile情况下需要主动设置下高度
                const elem = document.querySelector('.component-register-trial-form__scroll-wrapper');
                if (elem) {
                    const rc = elem.getBoundingClientRect();
                    // 需要加上外面的padding
                    parentIFrame.size(rc.height + 60);
                }
            }
        }
        this.outputChannel.fire({
            uid,
            command: E_ServerCommand.SwitchIframeResizerReply,
        });
    }
}
export function makeProxyService() {
    const service = new ServerService();
    return service;
}
